import Ability from './model';

export default Ability;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/Abilities/index.js